import SideBarLayout from "src/v2/layout/side-bar-layout"
import React, { useState } from "react"
import { Paper, Box, Grid } from "@mui/material"
import CadastroLoteUpload from "./components/cadastro-lote-upload"
import CadastroLoteTable from "./components/cadastro-lote-table"
import { cadastroLoteColumnsTable } from "./components/cadastro-lote-columns-table"

export const MotorCadastroLotePage = () => {
    const pageTitle = "Cadastro em Lote"
    const columns = cadastroLoteColumnsTable()

    const [nomeArquivo, setNomeArquivo] = useState("")
    const [projetar, setProjetar] = useState("nao")

    const rows = [
        {
            id: 1,
            modelo: "MC_EmissaoRendaFixaParametros",
            status: "Processando",
            totalRegistros: 150,
            progresso: 50,
            logErro: "-",
            usuario: "Mayara",
            dataCriacao: "2026-03-26T17:41:33.086736",
            dataAtualizacao: "2026-04-26T17:54:20.880598",
        },
        {
            id: 2,
            modelo: "MC_EmissaoRendaFixaEventosOrdinarios",
            status: "Processando",
            totalRegistros: 150,
            progresso: 100,
            logErro: "-",
            usuario: "Mayara",
            dataCriacao: "2026-03-26T17:41:33.086736",
            dataAtualizacao: "2026-04-26T17:54:20.880598",
        },
    ]

    return (
        <SideBarLayout
            title={pageTitle}
            //loading={loading}
            header={true}
            headerTitle="Cadastro em Lote"
            headerImage={"/background/eventos_headers.jpg"}
            headerPosition={"1% 41%"}
        >
            <Grid item xs={10} md={3}>
                <Paper sx={{ p: 3, borderRadius: 0, mb: 2, mt: -2 }}>
                    <Box
                        sx={{
                            flex: 1,
                            overflowX: "auto",
                            width: "100%",
                            display: "block",
                        }}
                    >
                        <CadastroLoteUpload
                            nameFile={nomeArquivo}
                            setNameFile={setNomeArquivo}
                            projetar={projetar}
                            setProjetar={setProjetar}
                            //onSend={handleEnviar}
                        />
                    </Box>
                </Paper>
            </Grid>


            <Grid item xs={12} md={3}>
                <Paper sx={{ p: 3, borderRadius: 0 }}>
                    <Box
                        sx={{
                            flex: 1,
                            overflowX: "auto",
                            width: "100%",
                            display: "block",
                        }}
                    >
                        <CadastroLoteTable
                            rows={rows}
                            columns={columns}
                            loading={false}
                            onReload={() => {
                                console.log("recarregar tabela")
                            }}
                        />
                    </Box>
                </Paper>
            </Grid>
        </SideBarLayout>
    )
}

export default MotorCadastroLotePage